/* eslint-disable @typescript-eslint/no-explicit-any */
import { IGetUserQuery, IUser } from 'interface/user.interface';
import axiosClient from './axiosClient';

const RoleBasedAuth = {
  getUsers: async (
    params: IGetUserQuery
  ): Promise<{ data: IUser[]; total: number }> => {
    return await axiosClient.get('/abe/user', { params });
  },
  setRole: async (payload: { id: number; group: string }): Promise<any> => {
    return await axiosClient.put('/abe/user', payload);
  },
  getRoles: async (): Promise<any> => {
    return await axiosClient.get('/abe/user/roles');
  },
  updateRoleByHS: async ({
    userId,
    role,
    groups,
  }: {
    userId: number;
    role: string;
    groups: string;
  }): Promise<any> => {
    return await axiosClient.put(`/abe/user/role/${userId}`, {
      role,
      userId,
      groups,
    });
  },

  updateUserByHS: async (param: any): Promise<any> => {
    return await axiosClient.put(`/pbe/binding_user/pms`, param);
  },

  postSyncAsmUserPlant: (param: any): Promise<any> => {
    const data = {
      data: param,
    };
    return axiosClient.post('/abe/user/sync-asm-user-plant', data);
  },
};
export default RoleBasedAuth;
